import React from 'react';

const Copyright = () =>{
    return(
        <>
        <section className='container-fluid container--copyright'>
            <div className='section-width custom-padding'>
                <div className='creation-text'>
                    <p>
                        Made with &#x2764;&#xfe0f; by Orneto, India
                    </p>
                    <p>
                        &#169; Copyright 2024-2025 Gayatri Home Tuition, India
                    </p>
                </div>
            </div>
        </section>
        </>
    )
}
export default Copyright;